export class FilePermission{
    static PERMISSIONS_ALL=0;
    static PERMISSIONS_ONLY_GROUP=1;
    static PERMISSIONS_ONLY_USER=2;
}